import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const CATEGORIES = [
  {
    name: "Getting started",
    faqs: [
      ["Are you a registered NDIS provider?", "Yes. Alpha Community Care is a registered NDIS provider. We operate under the NDIS Practice Standards with active quality, safeguarding and clinical governance."],
      ["Where do you deliver services?", "We currently deliver services across Victoria (head office in Docklands, Melbourne) and Western Australia (operations in West Perth and surrounding suburbs)."],
      ["How do I start a service with Alpha?", "Call 1300 380 692, email hello@alphacommunitycare.com.au, or submit our online referral form. We respond within one business day."],
    ],
  },
  {
    name: "Services & funding",
    faqs: [
      ["What services does Alpha provide?", "Assistance with Daily Living, Supported Independent Living (SIL), Support Coordination, Community Participation, Community Nursing Care, Forensic Disability Services, In-Home Support, Specialist Disability Accommodation (SDA), Short Term Accommodation (STA) and Medium Term Accommodation (MTA)."],
      ["Do you support complex and forensic needs?", "Yes. Our 24/7 SIL homes include forensic-overlay placements delivered by specifically-trained staff with strong clinical oversight."],
      ["Do I need NDIS funding to use Alpha's services?", "Most of our supports are NDIS-funded. If you're unsure whether your plan covers what you need, our intake team can walk through it with you."],
    ],
  },
  {
    name: "Homes & vacancies",
    faqs: [
      ["What types of homes do you offer?", "SIL (24/7 supported), SDA across all four design categories, STA (respite/short stay) and MTA (bridging accommodation)."],
      ["How do I book a tour?", "Open any vacancy on the Our Homes page and submit the enquiry form. We'll arrange a tour or virtual walkthrough that fits your timeline."],
      ["Can I move in with an existing housemate or partner?", "Where possible, yes. We'll work with you and your coordinator to find or configure the right home."],
    ],
  },
  {
    name: "Coordinators & referrers",
    faqs: [
      ["How do I refer a participant?", "Use our Coordinator referral form or email intake directly. We acknowledge referrals within 2 business hours."],
      ["How do you communicate during a placement?", "Named contacts, documented meetings, monthly progress summaries, and open channels with coordinators and allied health."],
      ["Can Alpha take crisis referrals?", "We assess crisis and priority referrals case-by-case, including forensic, discharge and safety-of-home scenarios."],
    ],
  },
];

function Row({ q, a, i }) {
  const [open, setOpen] = useState(i === 0);
  return (
    <div className="alpha-card p-0 overflow-hidden">
      <button onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between gap-4 p-5 text-left" data-testid={`faq-row-${i}`}>
        <span className="font-display text-base font-semibold pr-4">{q}</span>
        <ChevronDown className={`w-5 h-5 shrink-0 text-[color:var(--alpha-mute)] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-5 pb-5 text-sm text-[color:var(--alpha-mute)] leading-relaxed">{a}</div>}
    </div>
  );
}

export default function FAQPage() {
  return (
    <div data-testid="page-faq">
      <section className="alpha-gradient-hero border-b border-[color:var(--alpha-line)]">
        <div className="alpha-container pt-14 pb-10">
          <div className="alpha-overline">Help centre</div>
          <h1 className="mt-3 text-4xl sm:text-[52px] font-display font-medium tracking-tight leading-[1.05]">Questions, answered.</h1>
          <p className="mt-5 max-w-2xl text-lg text-[color:var(--alpha-mute)]">Everything we're commonly asked — in plain English. Can't find it here? Call 1300 380 692 and we'll help.</p>
        </div>
      </section>

      <section className="alpha-section">
        <div className="alpha-container max-w-3xl space-y-12">
          {CATEGORIES.map((cat) => (
            <div key={cat.name}>
              <div className="alpha-overline">{cat.name}</div>
              <div className="mt-4 space-y-3">
                {cat.faqs.map(([q, a], i) => <Row key={q} q={q} a={a} i={i} />)}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
